export function isPublicAuthPath(pathname) {
  return pathname === '/login' || pathname === '/api-docs';
}
